import React from "react";
import { useHistory } from "react-router-dom";
import { Breadcrumb, BreadcrumbItem, CodedProperty } from "sprint-common-web";

import { ContentSubtype } from "../../../common/types/ContentSubtype";
import { assetsSearchRoutes } from "../../AssetsRoutes";
import { getSearchAssetRouteItemByContentSubtype } from "../../search/getSearchAssetPathByType";

interface AncillaryAssetsListBreadcrumbsProps {
    ancillaryTitle: string;
    ancillaryVersionType: string;
    ancillaryAirlines?: CodedProperty[];
    contentType: ContentSubtype;
    isLoading: boolean;
}

export const AncillaryAssetsListBreadcrumbs: React.FC<AncillaryAssetsListBreadcrumbsProps> = (
    props: AncillaryAssetsListBreadcrumbsProps
) => {
    const history = useHistory();

    const { ancillaryTitle, contentType, ancillaryVersionType, ancillaryAirlines, isLoading } = props;

    const goToAncillaryAssetsSearchPage = () => {
        const routeItem = getSearchAssetRouteItemByContentSubtype(contentType);
        history.push(routeItem.path);
    };

    const airlineCodes = ancillaryAirlines?.map((airline: CodedProperty) => airline.code).join(", ");

    const items: BreadcrumbItem[] = [
        ...assetsSearchRoutes.baseRouteNames.map((name: string) => {
            return { key: name, text: name };
        }),
        {
            key: "search-breadcrumb",
            text: getSearchAssetRouteItemByContentSubtype(contentType).name,
            onClick: goToAncillaryAssetsSearchPage
        },
        {
            key: "ancillary-name-breadcrumb",
            text: `${ancillaryTitle} - ${ancillaryVersionType} - ${airlineCodes}`
        }
    ];

    return <Breadcrumb items={items} isLoading={isLoading} />;
};
